import React, { createRef, useEffect } from "react";

import "./pieceIconDisplay.css";
import HeartIcon from "../../assets/icons/heartIcon";
import DownloadIcon from "../../assets/icons/downloadIcon";
import ClockIcon from "../../assets/icons/clockIcon";
import HourglassIcon from "../../assets/icons/hourglassIcon";
import OriginalIcon from "../../assets/icons/originalIcon";
import TranscriptionIcon from "../../assets/icons/transcriptionIcon";
import { PieceIconDisplayProps } from "./pieceIconDisplay";

export default function PieceIconDisplayMobile(props: PieceIconDisplayProps) {

    return <div className="piece-icon-display mobile">
        <div className="piece-icon-display-item">
            <HeartIcon/>
            <span>{props.likes}</span>
        </div>
        <div className="piece-icon-display-item">
            <DownloadIcon/>
            <span>{props.downloads}</span>
        </div>
        <div className="piece-icon-display-item">
            <HourglassIcon/>
            <span>{props.duration} min</span>
        </div>
        <div className="piece-icon-display-item">
            <ClockIcon/>
            <span>{props.year}</span>
        </div>
        {props.original && <div className="piece-icon-display-item original">
            {props.original ? <OriginalIcon/> : <TranscriptionIcon/>}
        </div>}
    </div>;
}